import React from 'react'
import Works from '../../json/Works.json'
import Arrow from '../../assets/img/arrow-back.png'
import Default from '../../assets/img/default.jpg'


const Portfolio = () => (
    <section id="portfolio" className="portfolio">
        <h6 data-aos="fade-up" className="title">Portfolio</h6>
                
            <article data-aos="fade-up" className="works">
                { Works.map( work => 
                    <div className="work-card" key={work.id}>
                        <img 
                            src={ work.image === 'undefined' ? Default : work.image } 
                            alt={work.image} 
                            width="100%"
                        />}

                        <div className="card-content">
                            <h6 className="name">{work.name}</h6>
                            <p className="description">{work.description}</p>
                            <a 
                                target="_blank" 
                                className="btn btn-secondary" 
                                rel="noopener noreferrer"
                                href={ work.link === 'undefined' ? work.repository : work.link }>
                                {work.link === 'undefined' ? 'Ir a Github' : 'Ir al sitio web'}
                            </a>

                        </div>
                    </div>
                ) }
            </article>

            <a 
                data-aos="fade-up"
                target="_blank"
                className="githubButton btn btn-primary" 
                href="https://github.com/mawaraujo">
                Ver más en Github
                </a>
    </section>
)


export default Portfolio;